import { useEffect, useState } from "react";
import { Factory, FlaskConical, Zap, Landmark, Building2, Fuel, ShoppingBag, Truck, HeartPulse, Milk, Shirt, Store, Plane, Radio } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getIndustries } from "@/lib/api";

const ICONS = [Factory, FlaskConical, Zap, Landmark, Building2, Fuel, ShoppingBag, Truck, HeartPulse, Milk, Shirt, Store, Plane, Radio];

export default function Industries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    getIndustries()
      .then((d) => { if (mounted) setItems(d); })
      .catch(() => { if (mounted) setItems([]); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div data-testid="industries-page">
      <section className="border-b border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-24 sm:py-32">
          <div className="overline">Industries</div>
          <h1 className="font-serif text-5xl sm:text-6xl tracking-tight leading-[1.05] mt-6 text-[#0F172A] max-w-3xl">
            SAP, shaped to your industry.
          </h1>
          <p className="text-lg text-gray-600 mt-8 max-w-2xl leading-relaxed">
            Repeatable accelerators built on years of vertical practice — so your team avoids the trap of &ldquo;vanilla SAP&rdquo; without losing standardisation.
          </p>
        </div>
      </section>

      <section className="py-20 sm:py-24" data-testid="industries-grid-section">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {loading && <div className="text-gray-500" data-testid="industries-loading">Loading industries…</div>}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            {items.map((it, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={it.name} delay={i * 60}>
                  <div data-testid={`industry-card-${i}`} className="bg-white p-10 h-full flex flex-col justify-between min-h-[260px] hover:bg-gray-50 transition">
                    <Icon size={28} strokeWidth={1.4} className="text-[#111827]" />
                    <div className="mt-12">
                      <div className="font-serif text-2xl text-[#0F172A]">{it.name}</div>
                      <p className="text-gray-600 mt-3 leading-relaxed text-[15px]">{it.blurb}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
